
// Generated from  DocumentReader.cs

import { ApiRequestAsync } from "./ApiRequest";
import { Promise } from 'es6-promise';
import { InputType, InputText, InputNumber, InputBoolean, InputChoice, InputFile, InputDate, PrivilegeMembership, FileNote, LanguageInfo, RemoveQuery, FilterMode, ValueCaptionPair } from "./Shared";


export function putFileNotesAsync(fileNotes: FileNote[]): Promise<number> {
    return ApiRequestAsync<number>('IDocumentReaderApi', 'PutFileNotesAsync', fileNotes);
}

export function queryFileNotesAsync(updateQuery: DocumentUpdateQuery): Promise<FileNote[]> {
    return ApiRequestAsync<FileNote[]>('IDocumentReaderApi', 'QueryFileNotesAsync', updateQuery);
}

export function requestDownloadAsync(downloadRequest: DownloadRequest): Promise<OfflineStatus> {
    return ApiRequestAsync<OfflineStatus>('IDocumentReaderApi', 'RequestDownloadAsync', downloadRequest);
}

export function cancelDownloadAsync(fileGuid: string): Promise<void> {
    return ApiRequestAsync<void>('IDocumentReaderApi', 'CancelDownloadAsync', fileGuid);
}

export function requestUpdateAsync(request: UpdateRequest): Promise<OfflineStatus> {
    return ApiRequestAsync<OfflineStatus>('IDocumentReaderApi', 'RequestUpdateAsync', request);
}

export function deleteFilesAsync(files: DeleteQuery[]): Promise<void> {
    return ApiRequestAsync<void>('IDocumentReaderApi', 'DeleteFilesAsync', files);
}

export function updateFileResultInfoAsync(fileId: string): Promise<FileResultInfo> {
    return ApiRequestAsync<FileResultInfo>('IDocumentReaderApi', 'UpdateFileResultInfoAsync', fileId);
}

export function getDownloadStatusAsync(statusQuery: StatusQuery): Promise<OfflineStatus> {
    return ApiRequestAsync<OfflineStatus>('IDocumentReaderApi', 'GetDownloadStatusAsync', statusQuery);
}

export function queryDocumentUpdatesAsync(updateQuery: DocumentUpdateQuery): Promise<DocumentUpdateInfo[]> {
    return ApiRequestAsync<DocumentUpdateInfo[]>('IDocumentReaderApi', 'QueryDocumentUpdatesAsync', updateQuery);
}

export function getDocumentFiltersAsync(query: DocumentQuery): Promise<DocumentSearchFilters> {
    return ApiRequestAsync<DocumentSearchFilters>('IDocumentReaderApi', 'GetDocumentFiltersAsync', query);
}

export function getDocumentSearchFilterAllValuesAsync(filterQuery: MoreFilterValuesQuery): Promise<DocumentSearchFilter> {
    return ApiRequestAsync<DocumentSearchFilter>('IDocumentReaderApi', 'GetDocumentSearchFilterAllValuesAsync', filterQuery);
}

export function queryDocumentsAsync(query: DocumentQuery): Promise<DocumentResult> {
    return ApiRequestAsync<DocumentResult>('IDocumentReaderApi', 'QueryDocumentsAsync', query);
}

export function getTypeAheadAsync(query: TypeAheadQuery): Promise<TypeAheadSuggestion[]> {
    return ApiRequestAsync<TypeAheadSuggestion[]>('IDocumentReaderApi', 'GetTypeAheadAsync', query);
}

export function getDocumentFilesAsync(fileGuids: string[]): Promise<RecentFileInfo[]> {
    return ApiRequestAsync<RecentFileInfo[]>('IDocumentReaderApi', 'GetDocumentFilesAsync', fileGuids);
}

export function getFileGuidAsync(shareFileQuery: ShareFileQuery): Promise<string> {
    return ApiRequestAsync<string>('IDocumentReaderApi', 'GetFileGuidAsync', shareFileQuery);
}

export function getFileViewDetailsAsync(fileId: string): Promise<FileViewDetails> {
    return ApiRequestAsync<FileViewDetails>('IDocumentReaderApi', 'GetFileViewDetailsAsync', fileId);
}

export function getDocumentChaptersAsync(fileGuid: string): Promise<Chapter[]> {
    return ApiRequestAsync<Chapter[]>('IDocumentReaderApi', 'GetDocumentChaptersAsync', fileGuid);
}

export function getDocumentMetasAsync(fileGuid: string): Promise<ReaderMetaInfo[]> {
    return ApiRequestAsync<ReaderMetaInfo[]>('IDocumentReaderApi', 'GetDocumentMetasAsync', fileGuid);
}

export function createDeepLinkAsync(query: DocumentQuery): Promise<string> {
    return ApiRequestAsync<string>('IDocumentReaderApi', 'CreateDeepLinkAsync', query);
}

export function sendFeedbackAsync(feedback: Feedback): Promise<SendFeedbackResult> {
    return ApiRequestAsync<SendFeedbackResult>('IDocumentReaderApi', 'SendFeedbackAsync', feedback);
}


export function queryUpdatedDocumentsAsync(): Promise<DocumentResult> {
    return ApiRequestAsync<DocumentResult>('IDocumentReaderApi', 'QueryUpdatedDocumentsAsync');
}

export function getMetasJsonAsync(): Promise<string> {
    return ApiRequestAsync<string>('IDocumentReaderApi', 'GetMetasJsonAsync');
}

export function getMetaLanguagesJsonAsync(): Promise<string> {
    return ApiRequestAsync<string>('IDocumentReaderApi', 'GetMetaLanguagesJsonAsync');
}

export function getMetaValuesJsonAsync(): Promise<string> {
    return ApiRequestAsync<string>('IDocumentReaderApi', 'GetMetaValuesJsonAsync');
}

export function getMetaValueLanguagesJsonAsync(): Promise<string> {
    return ApiRequestAsync<string>('IDocumentReaderApi', 'GetMetaValueLanguagesJsonAsync');
}

export function restoreDownloadedFilesAsync(): Promise<void> {
    return ApiRequestAsync<void>('IDocumentReaderApi', 'RestoreDownloadedFilesAsync');
}

export function searchEpubIndexAsync(epubSearchViewModel: EpubSearchViewModel): Promise<EpubSearchResult> {
    return ApiRequestAsync<EpubSearchResult>('IDocumentReaderApi', 'SearchEpubIndexAsync', epubSearchViewModel);
}

import { observable, IObservableArray } from "mobx";


export class DownloadRequest {
    fileId: string = "";
    documentId: string = "";
}

export class UpdateRequest {
    downloadRequest: DownloadRequest = new DownloadRequest();
    oldFile: DeleteQuery = new DeleteQuery();
}

export class DeleteQuery {
    guid: string = "";
    mimeType: string = "";
}

export class StatusQuery {
    fileId: string = "";
    mimeType: string = "";
}

export class DocumentSearchFilters {
    @observable fileCount: number;
    searchFilters: IObservableArray<DocumentSearchFilter> = observable.array([]);
}

export class DocumentSearchFilter {
    @observable name: string = "";
    @observable caption: string = "";
    @observable filterMode: FilterMode;
    values: IObservableArray<SearchFilterValue> = observable.array([]);
    @observable maxValues: number;
    @observable isHierarchy: boolean;
}

export class SearchFilterValue {
    @observable value: string = "";
    @observable caption: string = "";
    @observable occurrences: number;
    @observable isSelected: boolean;
    children: IObservableArray<SearchFilterValue> = observable.array([]);
}

export class DocumentQuery {
    searchExpression: string = "";
    fileVariants: string[] = [];
    fileGuids: string[] = [];
    filters: DocumentFilter[] = [];
    skip: number;
    top: number;
    sortBy: SortBy[] = [];
}

export class SortBy {
    name: string = "";
    reverse: boolean;
}

export class DocumentFilter {
    @observable name: string = "";
    values: IObservableArray<string> = observable.array([]);
}

export class DocumentResult {
    headers: IObservableArray<string> = observable.shallowArray([]);
    documents: IObservableArray<FileResultInfo> = observable.array([]);
}

export class EpubSearchResult {
    targetChapterIds: string[] = [];
    count: number = 0;
    targetChapters: TargetChapter[] = [];
}

export class EpubSearchViewModel {
    epubDocumentGuid: string;
    searchTerm: string;
}
export class TargetChapter {
    chapterTarget: string;
    occurance: number = 0;
    chapterStartIndex: string;
    chapterContentLength: string;
}

export class FileResultInfo {
    guid: string = "";
    fileLinkGuid: string = "";
    documentId: string = "";
    collectionId: string = "";
    region: string = "";
    language: string = "";
    languageName: string = "";
    mimeType: string = "";
    isCoverAvailable: boolean;
    @observable status: OfflineStatus;
    size: number;
    availableFileUpdate: AvailableFileUpdate = new AvailableFileUpdate();
    validFrom: string = "";
    validUntil: string = "";
    values: string[] = [];
}

export class AvailableFileUpdate {
    guid: string = "";
    mimeType: string = "";
}

export class MoreFilterValuesQuery {
    name: string = "";
    searchExpression: string = "";
    query: DocumentQuery = new DocumentQuery();
}

export class DocumentUpdateQuery {
    documents: DocumentUpdateQueryItem[] = [];
}

export class DocumentUpdateQueryItem {
    documentId: string = "";
    language: string = "";
    fileId: string = "";
    metaUpdated: Date;
    metaValueHash: string = "";
}

export class DocumentUpdateInfo {
    documentId: string = "";
    language: string = "";
    fileId: string = "";
    fileChange: FileChange;
    availableFileUpdate: AvailableFileUpdate = new AvailableFileUpdate();
}

export class ShareFileQuery {
    documentId: string = "";
    documentLanguage
    originalFileName: string = "";
}

export class RecentFileInfo {
    guid: string = "";
    name: string = "";
    downloadName: string = "";
    language: string = "";
    languageName: string = "";
    mimeType: string = "";
    region: string = "";
    documentId: string = "";
    collectionId: string = "";
    isCoverAvailable: boolean;
}

export class FileViewDetails {
    guid: string = "";
    name: string = "";
    downloadName: string = "";
    originalFilename: string = "";
    language: string = "";
    mimeType: string = "";
    canDownload: boolean;
    documentId: string = "";
    collectionId: string = "";
    isCoverAvailable: boolean;
    launchFile: string = "";
    isDeleted: boolean;
}

export class TypeAheadSuggestion {
    value: string = "";
    prefix: string = "";
    suffix: string = "";
    count: number;
}

export class TypeAheadQuery {
    searchExpression: string = "";
    fileVariants: string[] = [];
    filters: DocumentFilter[] = [];
}

export class Chapter {
    title: string = "";
    linkTarget: string = "";
    subChapters: Chapter[] = [];
    @observable isCurrent: boolean;
    @observable isExpanded: boolean;
}

export class ReaderMetaInfo {
    caption: string = "";
    separator: string = "";
    values: string[] = [];
    linkTargets: string[] = [];
}

export class Feedback {
    subject: string = "";
    message: string = "";
}

export class SendFeedbackResult {
    success: boolean;
    message: string = "";
}


export enum OfflineStatus {
    None = 0,
    Waiting = 1,
    Downloading = 2,
    Offline = 3,
    Error = 4,
    Update = 5,
}

export enum FileChange {
    MetaChanged = 1,
    FileUpdated = 2,
    Deleted = 4,
}


export function _ignoreCompilerError_TS6133(x: any): boolean {
    return (x instanceof InputText) ||
        (x instanceof InputBoolean) ||
        (x instanceof InputChoice) ||
        (x instanceof InputDate) ||
        (x instanceof InputFile) ||
        (x instanceof PrivilegeMembership) ||
        (x instanceof FileNote) ||
        (x instanceof LanguageInfo) ||
        (x instanceof RemoveQuery);
}

